<template>
    <div>
        <template v-if="plan.virtualPlan===false && !isCustom">
            <ul>
                <li>
                    <span :class="highlighterClass('visitFee')">
                        Visit Fee:
                        <span>
                            {{ (planValues.visitFee || 0) | currency }}
                        </span>
                    </span>
                </li>
                <li>
                    <span :class="highlighterClass('urgentCareFee')">
                        Urgent Care Fee:
                        <span>
                            {{ (planValues.urgentCareFee || 0) | currency }}
                        </span>
                    </span>
                </li>
                <li>
                    <span :class="highlighterClass('preventativeCareDesc')">
                        Preventative Care:
                        <span :class="highlighterClass('preventativeCareDesc')">
                            {{ planValues.preventativeCareDesc }}
                        </span>
                    </span>
                </li>
                <li>
                    <span :class="highlighterClass('afterHoursDesc')">
                        After Hours:
                        <span :class="highlighterClass('afterHoursDesc')">
                            {{ planValues.afterHoursDesc }}
                        </span>
                    </span>
                </li>
            </ul>
            <div class="row">
                <template v-for="(value,key) in planValues">
                    <template v-if="displayProperty(key)">
                        <template v-if="isBoolean(key)">
                            <div v-if="value" class="col-lg-6">
                                <span class="feature-offer">
                                    <span class="wl-circle"></span>
                                    <span :class="highlighterClass(key)">{{ booleanMapper[key] }}</span>
                                </span>
                            </div>
                            <template v-else>
                                <div v-if="!showOnlyOffered" class="col-lg-6">
                                    <span class="fa fa-times"></span>
                                    <span :class="highlighterClass(key)">{{ booleanMapper[key] }}</span>
                                </div>
                            </template>
                        </template>
                    </template>
                </template>
            </div>
        </template>
        <template v-if="plan.openTemplate">
            <div class="open-plan-template-setting" v-html="plan.openTemplate" :class="highlighterClass('openTemplate')">

            </div>
        </template>
        <template v-if="plan.fileId">
            <div class="plan-pdf-section">
                <div v-if="pdfReady" class="plan-pdf-toolbar">
                    <a
                        :href="pdfUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="wl-interactive plan-pdf-action"
                    >
                        <i class="fas fa-external-link-alt"></i>
                        Open in new tab
                    </a>
                </div>
                <div v-if="pdfLoadError" class="plan-pdf-fallback alert alert-light border">
                    Preview could not be loaded.
                    <a href="#" class="wl-interactive" @click.prevent="downloadPdf">Download the PDF</a>
                    instead.
                </div>
                <div v-else class="plan-pdf-frame-wrap">
                    <div v-if="!pdfReady" class="plan-pdf-loading">
                        <span class="plan-pdf-loading-text">Loading preview…</span>
                    </div>
                    <iframe
                        v-show="pdfReady"
                        class="plan-pdf-frame"
                        title="Plan document PDF preview"
                        :src="pdfUrl"
                    ></iframe>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {booleanPlanPropertiesMapper} from "../physicianProfileAndPlans/booleamPropertiesMapper.js";
    import {nonBooleanMapper} from "../physicianProfileAndPlans/NonBooleanMapper.js";
    import { common } from '../../../global/common.js';

    export default {
        name: "PlanSettings",
        props: {
            plan: {type: [Object], required: true},
            futurePlan: {type: [Object], required: false, default: null},
            showOnlyOffered: {type: [Boolean], required: true}
        },
        data() {
            return {
                booleanMapper: {...booleanPlanPropertiesMapper, chargesVisitFee: "Charges Visit Fee"},
                nonBooleanMapper: nonBooleanMapper,
                fileName: null,
                pdfReady: false,
                pdfLoadError: false,
            }
        },
        computed: {
            hasPendingChange() {
                return Boolean(this.futurePlan) && Boolean(this.futurePlan.planId);
            },
            planValues() {
                return this.hasPendingChange ? this.futurePlan : this.plan;
            },
            isCustom() {
                return this.hasValue(this.plan.openTemplate) || this.hasValue(this.plan.fileId);
            },
            pdfUrl() {
                return common.APP_CONFIG.API_URL + this.pdfFileUrl(this.plan.fileId, this.fileName);
            },
        },
        methods: {
            displayProperty(propertyName) {
                return booleanPlanPropertiesMapper.hasOwnProperty(propertyName);
            },
            isBoolean(propertyName) {
                return booleanPlanPropertiesMapper.hasOwnProperty(propertyName);
            },
            highlighterClass(propertyName) {
                return this.hasPendingChange && (this.plan[propertyName] != this.futurePlan[propertyName]) ? 'highlight' : '';
            },
            pdfFileUrl(fileId, fileName) {
                return "shared/GetPdfFile/" + fileId + "/" + fileName;
            },
            downloadPdf() {
                common.downloadFile(this.pdfFileUrl(this.plan.fileId, this.fileName), this.fileName);
            },
            checkPdfAvailable() {
                this.pdfLoadError = false;
                this.pdfReady = false;
                let xhr = new XMLHttpRequest();
                xhr.open('GET', this.pdfUrl);
                if (localStorage.acressaToken) {
                    xhr.setRequestHeader('Authorization', localStorage.acressaToken);
                }
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        this.pdfReady = true;
                    } else {
                        this.pdfLoadError = true;
                    }
                };
                xhr.onerror = () => {
                    this.pdfLoadError = true;
                };
                xhr.send();
            }
        },
        mounted() {
            this.fileName = this.plan.planName.replace(/\s+/g, '') + ".pdf";
            if (this.plan.fileId) {
                this.checkPdfAvailable();
            }
        }
    }
</script>

<style scoped>
    .highlight {
        background-color: yellow;
    }

    .wl-circle {
        left: 0;
        top: 5px;
    }

    .feature-offer {
        position: relative;
    }

    .plan-settings {
        display: flex;
        justify-content: space-around;
    }

    .plan-pdf-section {
        margin-top: 8px;
    }

    .plan-pdf-toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px 20px;
        margin-bottom: 10px;
    }

    .plan-pdf-action {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 0.95rem;
    }

    .plan-pdf-frame-wrap {
        position: relative;
        border: 1px solid #dee2e6;
        border-radius: 8px;
        overflow: hidden;
        background: #f1f3f5;
        min-height: 280px;
        max-height: min(70vh, 560px);
    }

    .plan-pdf-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 280px;
        padding: 24px;
    }

    .plan-pdf-loading-text {
        color: #6c757d;
        font-size: 0.95rem;
    }

    .plan-pdf-frame {
        display: block;
        width: 100%;
        height: min(70vh, 560px);
        min-height: 280px;
        border: 0;
        background: #fff;
    }

    .plan-pdf-fallback {
        margin-bottom: 0;
    }

</style>